import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import tmdbApi from "../../api/tmdbApi";

// Stripe's account_onboarding Account Link "refresh_url" lands here when the link
// it gave the client expired or was otherwise invalidated mid-flow (e.g. the
// client reloaded the page). There's nothing to show here - we just mint a fresh
// link and immediately continue the redirect to Stripe.
const StripeOnboardingRefresh = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    // Same as the return page: no clientid is read from the URL. The new onboarding
    // link is minted for whoever the session says is calling.
    const restart = async () => {
      try {
        const response = await tmdbApi.createStripeConnectOnboarding();
        const result = response?.result || response;
        const onboardingUrl = result?.onboardingUrl;

        if (!onboardingUrl) {
          setError(true);
          toast.error("Could not restart bank account setup.", { position: "bottom-center" });
          return;
        }

        window.location.href = onboardingUrl;
      } catch (err) {
        console.error("createStripeConnectOnboarding (refresh) error:", err);
        setError(true);
        toast.error("Could not restart bank account setup.", { position: "bottom-center" });
      }
    };

    restart();
  }, []);

  const handleBack = () => {
    const nextRoute = localStorage.getItem("stripeOnboardingNextRoute") || "/thankyou";
    const mandatory = localStorage.getItem("stripeOnboardingMandatory") === "1";
    navigate("/connectbankaccount", { state: { nextRoute, mandatory } });
  };

  return (
    <div className="stripe-flow-page" id="page-top">
      <ToastContainer position="bottom-right" id="toastContainer" />
      <div className="container" id="stripe-refresh-container">
        <div className="signin-wrapper" id="signin-wrapper">
          <div className="stripe-flow-body" id="stripe-refresh-section">
            <div className={`stripe-flow-card ${error ? "is-error" : ""}`.trim()} id="stripe-refresh-card">
              <div className="stripe-flow-card__media" id="stripe-refresh-icon-col">
                <span className="material-icons" aria-hidden="true">{error ? "error_outline" : "sync"}</span>
              </div>
              <div className="stripe-flow-card__content" id="stripe-refresh-col">
                {error ? (
                  <>
                    <span className="stripe-flow-pill" id="stripe-refresh-pill">
                      <span className="stripe-flow-pill__dot" />
                      Link expired
                    </span>
                    <h1 className="bold-heading" id="stripe-refresh-heading">We hit a snag</h1>
                    <p className="discription-text" id="stripe-refresh-text">
                      Your bank account setup link expired and we couldn't get a new one.
                    </p>
                    <div className="stripe-flow-actions" id="stripe-refresh-actions">
                      <button className="fill-btn" onClick={handleBack} id="stripe-refresh-back-btn">Try Again</button>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="stripe-flow-pill" id="stripe-refresh-pill">
                      <span className="stripe-flow-pill__dot is-pulsing" />
                      Reconnecting
                    </span>
                    <h1 className="bold-heading" id="stripe-refresh-heading">Reconnecting to Stripe...</h1>
                    <p className="discription-text" id="stripe-refresh-text">
                      Please wait, this will only take a moment.
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="login_footer" id="stripe-refresh-footer">
        <div className="container-fluid">
          <p className="footer-para" id="stripe-refresh-footer-text">
            © {new Date().getFullYear()} SpotSaver. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default StripeOnboardingRefresh;
